import React from 'react';
import { minimumSoftwareKnowledge, selectPreRequest } from '@pharmaplan/common';
import { useAppDispatch } from '../useAppDispatch';
import { setDialog } from '../../reducers/dialogReducer';
import OutcomeModal from '../../components/Modals/OutcomeModal';
import { OutcomeModalTypes } from '../../helpers/Constants';
import { useAppSelector } from '../useAppSelector';
import SoftwareWarning from '../../components/SelfService/ServiceWorkshiftDetails/SoftwareWarning';
import strings from '../../localization';

const usePreRequestUtils = () => {
  const dispatch = useAppDispatch();

  const preRequestStatus = useAppSelector(selectPreRequest);
  const { name } = preRequestStatus ?? {};

  const showSoftwareWarning = () => {
    dispatch(
      setDialog({
        heading: {
          title: '',
        },
        Component: (
          <OutcomeModal
            type={OutcomeModalTypes.softwareWarning}
            message={(
              <SoftwareWarning
                message={strings.formatString(
                  strings.softwareKnowledgeNotEnough,
                  minimumSoftwareKnowledge,
                  name,
                )}
              />
            )}
            showCloseButton
          />
        ),
        showCloseButton: false,
      }),
    );
  };

  return { showSoftwareWarning };
};

export default usePreRequestUtils;
